// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"cfcda663","787":"193b1055"}[chunkId] + ".chunk.js";
};